var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ListingSettingsHeader", {
    attrs: {
      totalResults: _vm.totalEmails,
      columns: _vm.columns,
      enableColumnsSettings: false,
      displayTotalResults: _vm.displayTotalResults,
      searchValue: _vm.searchValue,
      searchable: _vm.searchable,
      refreshable: _vm.refreshable,
      customTotalResultsLabel: _vm.customTotalResultsLabel
    },
    on: { search: _vm.handleSearch, refresh: _vm.handleRefresh }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }